import React, { useState } from 'react';
import Layout from "../../components/Wrappers/Layout";
import {
    Card,
    Alert,
} from "reactstrap";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { AiOutlineSearch } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { adminGetModuleMaster } from '../../redux/actions/adminGetModuleMasterApi';
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { useEffect } from 'react';
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import CustomButton from "../../components/CustomButton/CustomButton";
import { makeStyles } from "@mui/styles";
import SOLogout from "../../components/Logout/SOLogout";
import EditIcon from "@mui/icons-material/Edit";
import { adminAddEditModuleMaster } from '../../redux/actions/adminAddEditModuleMasterAction';
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import BackButton from '../../components/BackButton/BackButton';

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminAddModule = () => {
    const classes = useStyles();

    const [moduleName, setmoduleName] = useState('');
    const [role, setrole] = useState('');
    const [isLoading, setisLoading] = useState(false);
    const [moduleTableData, setmoduleTableData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [editModuleId, seteditModuleId] = useState('');
    const [editModuleName, seteditModuleName] = useState('');
    const [editModuleRole, seteditModuleRole] = useState('');
    const [editOpen, seteditOpen] = useState(false);
    const [updateset, setupdateset] = useState(false);
    const [editRespDescription, seteditRespDescription] = useState([]);
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [addModuleModal, setaddModuleModal] = useState(false);
    const [addModuleName, setaddModuleName] = useState('');
    const [addModuleRole, setaddModuleRole] = useState('');
    const [addModuleSet, setaddModuleSet] = useState(false);

    const openAddModuleModal = () => {
        setaddModuleModal(true);
    }

    const respAddModule = () => {
        if (addModuleSet) {
            if (addeditmastermodule.data.status === 'success') {
                setaddModuleModal(false);
                seteditRespDescription(addeditmastermodule.data.description);
                setnotificationOpen(true);
                searchFunction();
            }
            if (addeditmastermodule.data.status === 'failed') {
                setaddModuleModal(false);
                seteditRespDescription(addeditmastermodule.data.description);
                setnotificationOpen(true);
                searchFunction();
                if (
                    addeditmastermodule.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addeditmastermodule.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    const updateTable = () => {
        if (updateset) {
            if (addeditmastermodule.data.status === 'success') {
                seteditRespDescription(addeditmastermodule.data.description);
                setnotificationOpen(true);
                searchFunction();
            }
            if (addeditmastermodule.data.status === 'failed') {
                seteditRespDescription(addeditmastermodule.data.description);
                setnotificationOpen(true);
                searchFunction();
                if (
                    addeditmastermodule.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addeditmastermodule.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (addeditmastermodule.data.status === 'NOT FOUND') {
                seteditRespDescription(addeditmastermodule.data.description);
                setnotificationOpen(true);
                searchFunction();
            }
        }
    }

    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setaddModuleName('');
        setaddModuleRole('');
    }

    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'moduleName') {
            setmoduleName(value);
        }
        if (name === 'role') {
            setrole(value);
        }
    }

    const dispatch = useDispatch();

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    let authToken = regenerateTokenRes.data.AuthToken;

    const getmodulemasterlist = useSelector(({ getmodulemasterlist }) => getmodulemasterlist);

    const addeditmastermodule = useSelector(({ addeditmastermodule }) => addeditmastermodule);

    useEffect(() => {
        if (addeditmastermodule.data.status) {
            updateTable();
            respAddModule();
        }
    }, addeditmastermodule.data.status)

    const getMasterModuleListResponseFunc = () => {
        if (getmodulemasterlist) {
            if (getmodulemasterlist.data.status === 'success') {
                setmoduleTableData([].concat(getmodulemasterlist.data.errorList));
                setisLoading(false);
            }
            if (getmodulemasterlist.data.status === 'failed') {
                setmoduleTableData([]);
                setisLoading(false);
                if (
                    getmodulemasterlist.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getmodulemasterlist.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        getMasterModuleListResponseFunc();
    }, [getmodulemasterlist.data.status]);

    useEffect(() => {
        searchFunction();
    }, [])

    const searchFunction = () => {
        setisLoading(true);
        const getRequest = {
            actionCustomerMasterRequestVO: {
                moduleName: moduleName,
                role: role,
                moduleId: ''
            }
        }
        dispatch(adminGetModuleMaster(getRequest, authToken));
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const editModalOpen = (id, modulename, roles) => {
        seteditModuleId(id);
        seteditModuleName(modulename);
        seteditModuleRole(roles === '-' ? '' : roles);
        setupdateset(true);
        seteditOpen(true);
    }

    const handleClose = () => {
        seteditOpen(false);
        seteditModuleId('');
        seteditModuleName('');
        seteditModuleRole('');
    }

    const editFunction = () => {
        const editRequest = {
            actionCustomerMasterRequestVO: {
                moduleId: editModuleId,
                moduleName: editModuleName,
                role: editModuleRole
            }
        }
        dispatch(adminAddEditModuleMaster(editRequest, authToken));
        handleClose();
    }

    const changeEdit = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editmoduleid') {
            seteditModuleId(value);
        }
        if (name === 'editmodulename') {
            seteditModuleName(value);
        }
        if (name === 'editmodulerole') {
            seteditModuleRole(value);
        }
    }

    const addModuleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'addModuleName') {
            setaddModuleName(value);
        }
        if (name === 'addModuleRole') {
            setaddModuleRole(value);
        }
    }

    const addModuleSubmit = () => {
        const addModuleReq = {
            actionCustomerMasterRequestVO: {
                moduleName: addModuleName,
                role: addModuleRole,
                moduleId: ''
            }
        }
        dispatch(adminAddEditModuleMaster(addModuleReq, authToken));
        setaddModuleSet(true);
    }

    const closeaddModuleModal = () => {
        setaddModuleModal(false);
        setaddModuleName('');
        setaddModuleRole('');
    }

    useEffect(() => {
        if (getmodulemasterlist.data.status == "success") {
            setPage(0);
        }
    }, [getmodulemasterlist.data.status]);

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        style={{ padding: "15px", justifyContent: "right" }}
                        spacing={2}
                    >
                        <Grid item md={2} sm={12} xs={12} lg={3}>
                            {/* <NavLink to="/index/adminAddNewModule"> */}
                            <Button
                                size="small"
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                className="riskRuleButton"
                                onClick={openAddModuleModal}
                            >
                                Add Module
                            </Button>
                            {/* </NavLink> */}
                        </Grid>
                        <Grid item md={2} sm={12} xs={12} lg={3}>
                            <NavLink to="/index/adminAddSubModule">
                                <Button
                                    size="small"
                                    style={{
                                        backgroundColor: "#00b9f5",
                                        color: "white",
                                        margin: '0 auto',
                                        display: 'block',
                                        width: 'max-content'
                                    }}
                                    variant="contained"
                                    className="riskRuleButton"
                                >
                                    Add Sub Module
                                </Button>
                            </NavLink>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item sm={12} md={4} lg={4}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Module Name"
                                type="name"
                                fullWidth
                                variant="standard"
                                name="moduleName"
                                onChange={handleChange}
                                defaultValue={"" || moduleName}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                            </TextField>
                        </Grid>
                        <Grid item sm={12} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                id="role"
                                label="Role"
                                type="name"
                                fullWidth
                                variant="standard"
                                name="role"
                                onChange={handleChange}
                                defaultValue={"" || role}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="" selected="Select Role">
                                    Select Role
                                </MenuItem>
                                <MenuItem value="owner">Owner</MenuItem>
                                <MenuItem value="bank">Bank</MenuItem>
                                <MenuItem value="dealer">Dealer</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item sm={12} md={4} lg={4}>
                            <Button
                                style={{
                                    marginLeft: "0.7rem",
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                    marginTop: "17px"
                                }}
                                endIcon={<AiOutlineSearch />}
                                variant="contained"
                                onClick={searchFunction}
                            >
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                    {/*  */}
                </Card>

                {isLoading ? (<LoadingSpinner />) : (moduleTableData.length == undefined || moduleTableData.length == 0) ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Module Details
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Module Details
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table
                                    className={classes.table}
                                    style={{ padding: "6px 20px 6px 16px !important" }}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        {/* <TableRow style={{ background: "#00b9f5" }}> */}
                                        <TableRow className="tableHeaderColor">

                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Module ID
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Module Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Role
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {moduleTableData &&
                                            []
                                                .concat(moduleTableData)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">
                                                            {row.moduleId}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.moduleName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.role === '' ? '-' : row.role}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <CustomButton
                                                                style={{
                                                                    padding: "8px"
                                                                }}
                                                                onClick={() =>
                                                                    editModalOpen(row.moduleId, row.moduleName, row.role)
                                                                }
                                                            >
                                                                {
                                                                    <EditIcon
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontSize: "20px"
                                                                        }}
                                                                    />
                                                                }
                                                            </CustomButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={moduleTableData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}

            </Layout>

            {addeditmastermodule.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center popupBackgroundColor"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editRespDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addeditmastermodule.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center popupBackgroundColor"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editRespDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            <div>
                <Dialog open={editOpen} onClose={handleClose}>
                    <DialogTitle>Edit Module</DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            id="name"
                            label="Module ID"
                            type="number"
                            name='editmoduleid'
                            fullWidth
                            variant="standard"
                            value={editModuleId || ""}
                            onChange={changeEdit}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        />
                        <TextField
                            margin="dense"
                            id="name"
                            label="Module Name"
                            type="name"
                            name='editmodulename'
                            fullWidth
                            variant="standard"
                            value={editModuleName || ""}
                            onChange={changeEdit}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        />
                        {/* <TextField
                            margin="dense"
                            id="name"
                            label="Role"
                            type="name"
                            fullWidth
                            name='editmodulerole'
                            variant="standard"
                            value={editModuleRole || ""}
                            onChange={changeEdit}
                        /> */}
                        <TextField
                            select
                            margin="dense"
                            id="role"
                            label="Role"
                            type="name"
                            fullWidth
                            variant="standard"
                            name="editmodulerole"
                            onChange={changeEdit}
                            defaultValue={editModuleRole || ''}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        >
                            <MenuItem value="" selected="Select Role">
                                Select Role
                            </MenuItem>
                            <MenuItem value="OWNER">Owner</MenuItem>
                            <MenuItem value="BANK">Bank</MenuItem>
                            <MenuItem value="DEALER">Dealer</MenuItem>
                        </TextField>

                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <Button
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "#fff"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "#fff"
                            }}
                            variant="contained"
                            onClick={editFunction}
                        >
                            ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div>
                <Dialog open={addModuleModal} onClose={closeaddModuleModal}>
                    <DialogTitle>Add Module</DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            required
                            id="name"
                            label="Module Name"
                            type="name"
                            name='addModuleName'
                            fullWidth
                            variant="standard"
                            value={addModuleName || ""}
                            onChange={addModuleChange}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        />
                        <TextField
                            select
                            margin="dense"
                            id="role"
                            label="Role"
                            type="name"
                            fullWidth
                            variant="standard"
                            name="addModuleRole"
                            onChange={addModuleChange}
                            defaultValue={addModuleRole || ''}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        >
                            <MenuItem value="" selected="Select Role">
                                Select Role
                            </MenuItem>
                            <MenuItem value="owner">Owner</MenuItem>
                            <MenuItem value="bank">Bank</MenuItem>
                            <MenuItem value="dealer">Dealer</MenuItem>
                        </TextField>

                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            variant="contained"
                            onClick={closeaddModuleModal}
                        >
                            Cancel
                        </CustomButton>
                        {/* <Button
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "#fff"
                            }}
                            variant="contained"
                            disabled={!addModuleName}
                            onClick={addModuleSubmit}
                        >
                            Add
                        </Button> */}
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            disabled={!addModuleName}
                            onClick={addModuleSubmit}
                        >
                            Add
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    )
}

export default AdminAddModule